<template>
  <div>{{ currentUser.active_chat }}</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { usersStore } from '@/src/store/users';

const users = usersStore();
const { currentUser } = storeToRefs(users);

onMounted(() => {
});
</script>

<script lang="ts">
export default {
  name: 'SeChatHeader',
};
</script>
